<template>
  <div class="com-header">
    <div class="center-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
      <template v-for="(item, index) of data">
        <el-breadcrumb-item :to="{ path: item.to }"  :key="index" v-if="item.to">{{item.title}}</el-breadcrumb-item>
        <el-breadcrumb-item  :key="index" v-else>{{item.title}}</el-breadcrumb-item>
      </template>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Array
  }
};
</script>

<style lang='scss'>
.com-header {
  height: 50px;
  background: url('../../assets/img/breadBg.svg');
  background-size: cover;     
  display: flex;
  align-items: center;
  .el-icon-arrow-right {
    color: #fff;
  }
  .el-breadcrumb__inner {
    color: #fff !important;
  }
  .el-breadcrumb__inner.is-link {
    font-weight: 500;
  }
}
</style>